import apiClient from '@/apis/client';

export enum ResponseGetWalletType {
  ADD = 'ADD',
  DEDUCT = 'DEDUCT',
}

export interface ResponseGetWallet {
  balance: number;
  transactions: {
    id: string;
    date: Date;
    amount: number;
    balanceAfter: number;
    type: ResponseGetWalletType;
    action: string;
    reference: object;
    link?: string;
  }[];
}

export default async function getWalletApi(
  token: string
): Promise<ResponseGetWallet> {
  return apiClient.get<ResponseGetWallet>('/wallet', { token });
}
